"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PrivatePlacementDetails = void 0;

var _react = _interopRequireDefault(require("react"));

var _index = _interopRequireDefault(require("./index.styled"));

var _IconLibrary = require("../IconLibrary");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var PrivatePlacementDetails = function PrivatePlacementDetails(_ref) {
  var targetReturn = _ref.targetReturn,
      cashOnCash = _ref.cashOnCash,
      returnOnCost = _ref.returnOnCost,
      targetEquityMultiple = _ref.targetEquityMultiple,
      targetHoldMin = _ref.targetHoldMin,
      minimum = _ref.minimum,
      propertyType = _ref.propertyType;
  return /*#__PURE__*/_react.default.createElement(_index.default.Details, null, /*#__PURE__*/_react.default.createElement("div", {
    id: "private-stats"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "line"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "label"
  }, "Target IRR*"), /*#__PURE__*/_react.default.createElement("span", {
    className: "value"
  }, targetReturn, "%")), cashOnCash ? /*#__PURE__*/_react.default.createElement("div", {
    className: "line"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "label"
  }, "Target Cash on Cash*"), /*#__PURE__*/_react.default.createElement("span", {
    className: "value"
  }, cashOnCash, "%")) : null, returnOnCost && !cashOnCash ? /*#__PURE__*/_react.default.createElement("div", {
    className: "line"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "label"
  }, "Target Return on Cost*"), /*#__PURE__*/_react.default.createElement("span", {
    className: "value"
  }, returnOnCost, "%")) : null, /*#__PURE__*/_react.default.createElement("div", {
    className: "line"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "label"
  }, "Target Equity Multiple*"), /*#__PURE__*/_react.default.createElement("span", {
    className: "value"
  }, targetEquityMultiple, "X")), /*#__PURE__*/_react.default.createElement("div", {
    className: "line"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "label"
  }, "Target Hold Period*"), /*#__PURE__*/_react.default.createElement("span", {
    className: "value"
  }, Math.floor(targetHoldMin / 12), " Years"))), /*#__PURE__*/_react.default.createElement("div", {
    className: "stacked-stats"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "stacked-stats"
  }, "$", minimum / 1000, "K", /*#__PURE__*/_react.default.createElement("div", {
    className: "value"
  }, "MINIMUM")), /*#__PURE__*/_react.default.createElement("div", {
    className: "bar"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "stacked-stats"
  }, /*#__PURE__*/_react.default.createElement(_IconLibrary.CRE, {
    width: "36px",
    height: "36px"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "value"
  }, propertyType))));
};

exports.PrivatePlacementDetails = PrivatePlacementDetails;